import { put, takeLatest } from 'redux-saga/effects';
import { LogAccessi } from '../../reducers/r_index';

import authService from '../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { codiceUtente } }) {
    try {

        const token = yield authService.getAccessToken();

        const response = yield fetch('/Log/GetLogAccessi/' + codiceUtente, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const requestResult = yield response.json();

        //creo l'array contenente i log degli accessi
        var log_accessi = requestResult;

        yield put(LogAccessi.creators.getLogAccessiSuccess({ log_accessi }));

    } catch (e) {
        yield put(LogAccessi.creators.getLogAccessiFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(LogAccessi.types.GET_LOG_ACCESSI_REQUEST, runAction);
}



/* esempio risposta
var log_accessi = [
      {
        ID: '1',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '2',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '3',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '4',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '5',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '6',
        ProductKey: 'CPTKS-SP02V-ALMWH-Q30Q2',
        IP: '217.194.185.81\r\n',
        MAC: '0A:00:27:00:00:13',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '7',
        ProductKey: 'CPTKS-SP02V-ALMWH-Q30Q2',
        IP: '217.194.185.81\r\n',
        MAC: '0A:00:27:00:00:13',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '8',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '9',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '10',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '11',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '12',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '13',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '14',
        ProductKey: 'W3JGG-G01LA-W4QMW-RCPIG',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-20T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '15',
        ProductKey: 'CPTKS-SP02V-ALMWH-Q30Q2',
        IP: '217.194.185.81\r\n',
        MAC: '0A:00:27:00:00:13',
        DataAccesso: '2019-05-21T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '16',
        ProductKey: 'VFB93-35DD9-41T2D-4LV5W',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-30T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '17',
        ProductKey: 'VFB93-35DD9-41T2D-4LV5W',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-30T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '18',
        ProductKey: 'VFB93-35DD9-41T2D-4LV5W',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-30T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '19',
        ProductKey: 'VFB93-35DD9-41T2D-4LV5W',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-30T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '20',
        ProductKey: 'VFB93-35DD9-41T2D-4LV5W',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-30T00:00:00+02:00',
        CodiceUtente: ''
      },
      {
        ID: '21',
        ProductKey: 'VFB93-35DD9-41T2D-4LV5W',
        IP: '217.194.185.81\r\n',
        MAC: '02:15:22:7E:51:63',
        DataAccesso: '2019-05-30T00:00:00+02:00',
        CodiceUtente: ''
      }
];


*/